<template>
  <div>
    <b-row class="justify-content-center footer">
      <div class="col-lg-4 col-8">
        <div field="text" tabindex="0">
          <div style="color:#dddddd;" data-customstyle="yes">
            © 2018
            <a href="https://sibel.by" target="_blank" tabindex="-1"
              >{{ $t("footerTitle1") }}
            </a>
            {{ $t("footerTitle2") }}
            <a href="https://center1.by" target="_blank" tabindex="-1"
              >{{ $t("footerTitle3") }}
            </a>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  padding: 30px 0 40px;
  margin: 0;
  background-color: black;
  width: 100%;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
